// IndexedDB cache for per-region FeatureCollections: the last successful
// load renders instantly on the next visit (fully interactive stale copy)
// while the fresh fetch runs. Failures degrade silently — no cache is never
// an error, it just means the PNG placeholder carries the load window.

const DB_NAME = 'weinberge';
const STORE = 'regions';

function withStore(txMode, fn) {
  return new Promise((resolve, reject) => {
    const open = indexedDB.open(DB_NAME, 1);
    open.onupgradeneeded = () => open.result.createObjectStore(STORE);
    open.onerror = () => reject(open.error);
    open.onsuccess = () => {
      const db = open.result;
      const tx = db.transaction(STORE, txMode);
      const req = fn(tx.objectStore(STORE));
      tx.oncomplete = () => { db.close(); resolve(req?.result); };
      tx.onerror = () => { db.close(); reject(tx.error); };
    };
  });
}

export function regionCacheGet(region) {
  try {
    return withStore('readonly', s => s.get(region)).catch(() => null);
  } catch {
    return Promise.resolve(null);   // no IndexedDB (private mode etc.)
  }
}

export function regionCacheSet(region, fc) {
  try {
    return withStore('readwrite', s => s.put(fc, region)).catch(() => {});
  } catch {
    return Promise.resolve();
  }
}
